import styled from "styled-components";
import {UserMenuSectionDefaultBox} from "./user-menu-section.default.box";

export const UserMenuSectionCasino777Box = styled(UserMenuSectionDefaultBox)`
  background-color: ${({theme}) => theme.colors.logoBackground };
`